import { render, staticRenderFns } from "./AddOntologyModal.vue?vue&type=template&id=7d71981f&"
import script from "./AddOntologyModal.vue?vue&type=script&lang=js&"
export * from "./AddOntologyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports